import { Component } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-enterprise';

@Component({
    selector: 'app-characteristics-cell-editor',
    templateUrl: './characteristics-cell-editor.component.html',
    styleUrls: ['./characteristics-cell-editor.component.scss'],
    standalone: false
})
export class CharacteristicsCellEditorComponent
  implements ICellEditorAngularComp
{
  params?: ICellEditorParams;
  potentialValues?: CharacteristicValue[];
  currentValue?: CharacteristicValue;

  agInit(params: ICellEditorParams): void {
    this.params = params;

    this.potentialValues =
      this.params.data.values || this.params.data.possibleValues;

    this.currentValue = this.params.value;
  }

  /* Component Editor Lifecycle methods */
  // the final currentValue to send to the grid, on completion of editing
  getValue() {
    return this.currentValue;
  }

  onSelectModelChange(value: CharacteristicValue) {
    this.currentValue = value;
  }

  onTextModelChange(value: string) {
    this.currentValue = {
      value,
      displayValue: value,
    };
  }
  constructor() {}
}

interface CharacteristicValue {
  value: string;
  displayValue: string;
}
